export function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
}

export function getCurrentUrl() {
  return location.href.split('?')[0];
}

export function getPageName() {
  let customTitleMetaTag = document.head.querySelector("meta[name='bpf-title']")
  if (!!customTitleMetaTag) {
    return customTitleMetaTag.content;
  }

  // fall back to url if the page doesn't have a title set
  return document.title || getCurrentUrl();
}

export function getPageMeta() {
  let customTitleMetaTag = document.head.querySelector("meta[name='bpf-meta']")

  if (!!customTitleMetaTag) {
    try {
      return JSON.parse(customTitleMetaTag.content);
    } catch (e) {
      if (typeof sentry  !== 'undefined') {
        sentry.hub.captureException(e, scope => {
          scope.clear();
          scope.setTransactionName("Analytics: getPageMeta");
          scope.setContext("Dom Info", {
            meta: customTitleMetaTag,
          });
          return scope;
        });
      }

      return null;
    }
  }

  return null;
}

// This function accepts two parameters: the URL to send the request to, and params, which is an object made up from 3
//   seperate objects: the headerParams, bodyParams, and urlParams
// The header params defines any authentication, and the HTTP method to be used
// The body params will be serialized into JSON and sent via the request body
// Finally, the URL params will be URL encoded and appended to the URL
export function AJAX(URL, { headerParams: { username, password, method = 'POST' }, bodyParams, urlParams } = {}) {
  return new Promise((resolve, reject) => {
    const xhttp = new XMLHttpRequest();
    if (urlParams) {
      URL += formatURLParams(urlParams);
    }

    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        resolve(JSON.parse(this.responseText));
      } else if ((this.readyState === 4 && this.status === 0) || String(this.status).match(/^[4|5]/)) {
        reject('Unexpected response');
      }
    };

    try {
      xhttp.open(method, URL, true);
      xhttp.setRequestHeader('Content-Type', 'application/JSON');
      if (username && password) {
        xhttp.setRequestHeader('Authorization', `Basic ${btoa(`${username}:${password}`)}`);
      }
      xhttp.send(JSON.stringify(bodyParams));
    } catch (e) {
      reject(e.message);
    }
  });
}

export function formatURLParams(params) {
  const urlParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    urlParams.set(key, value);
  }

  return `?${urlParams.toString()}`;
}

export function getQueryParam(param) {
  let searchString = window.location.search.substring(1);
  let params = searchString.split("&");

  for (let i = 0; i < params.length; i++) {
    var pair = params[i].split("=");
    if (pair[0] == param) {
      return pair[1];
    }
  }
}

export function setCookie(name, value) {
  document.cookie = `${name}=${value}; path=/`;
}

export function initializeGlobals() {
  global.BPF ||= {};
  global.BPF.Intercom ||= {};
}
